interface TooltipProps {
  content: string
  children: React.ReactNode
  disabled?: boolean
}

export default function Tooltip({ content, children, disabled = false }: TooltipProps) {
  if (disabled) {
    return <>{children}</>
  }

  return (
    <div className="relative group">
      {children}
      <div
        className="
          absolute left-full ml-2 top-1/2 -translate-y-1/2
          px-2 py-1 text-sm text-black whitespace-nowrap
          bg-white/90 backdrop-blur-md border border-black/10 rounded-lg shadow-lg
          opacity-0 invisible group-hover:opacity-100 group-hover:visible
          transition-all duration-200 delay-150
          z-50 pointer-events-none
        "
      >
        {content}
      </div>
    </div>
  )
}
